import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=d5c8cd2e&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=ts"
export * from "./Privacy.vue?vue&type=script&lang=ts"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=d5c8cd2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c8cd2e",
  null
  
)

export default component.exports